/**
 * Complete Modal
 *
 * Displays a modal when a section is completed and asks the user if they want to return to 
 * the overview page. It imports React, PropTypes, gatsby, Modal from react-bootstrap, and 
 * defines the CompleteModal class that renders the modal. The modal has a title, a message, 
 * and two buttons: one to navigate back to the overview page and another to cancel. 
 * The component takes three props: modalShow, modalDismissed, and modalClose, and sets 
 * default values for them.
 */

import React from 'react'
import PropTypes from 'prop-types'
import { navigate } from '../utils/navigate'
import Modal from 'react-bootstrap/Modal'

export default class CompleteModal extends React.Component {
  render() {
    const { modalShow, modalDismissed, modalClose } = this.props
    return (
      <Modal show={modalShow && !modalDismissed} onHide={modalClose} centered aria-labelledby="complete-modal-title">
        <Modal.Header closeButton>
          <Modal.Title id="complete-modal-title">Finished?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Looks like you&apos;ve completed everything here! Would you like to return to the overview page?</p>

          <button className={`btn btn-block btn-danger text-uppercase mt-4`} onClick={() => navigate(`/`)}>
            Yes!
          </button>
          <button className={`btn btn-block btn-tiny mt-4`} onClick={modalClose}>
            Cancel
          </button>
        </Modal.Body>
      </Modal>
    )
  }
}

CompleteModal.propTypes = {
  modalShow: PropTypes.bool,
  modalDismissed: PropTypes.bool,
  modalClose: PropTypes.func,
}

CompleteModal.defaultProps = {
  modalShow: false,
  modalDismissed: false,
  modalClose: () => {},
}
